
<template>
  <!--版本管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="appVersionId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
    </x-tabula>

    <!--二维码的弹窗-->
    <a-modal
      title="二维码"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <div style="text-align: center">
        <img style="width: 200px;" :src="imgUrl" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'appVersion',
  data () {
    return {
      imgUrl: '',
      visible: false,
      searchList: [
        { props: ['version'], placeholder: '版本号', inputType: 'input' },
        { props: ['appId'], placeholder: '选择应用', options: [], inputType: 'select' },
        { props: ['osType'], placeholder: '选择平台', options: [], inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:appVersion:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:appVersion:remove'] }
      ],
      rowOptList: [
        // {text: '下载二维码', handle: (row) => this.downloadQRcode(row.appVersionId), permi: ['community:appVersion:qrcode']},
        {text: '修改', handle: row => this.$refs.table.toEdit(row), permi: ['community:appVersion:edit']},
        {text: '删除', handle: row => this.$refs.table.showDeleteConfirm(row), permi: ['community:appVersion:remove']}
      ],
      columns: [
        { title: '版本号', dataIndex: 'version', align: 'left', width: '' },
        { title: '应用', dataIndex: 'appName', align: 'left', width: '' },
        // { title: 'Code', dataIndex: 'code', align: 'left', width: '' },
        { title: '平台', dataIndex: 'osDesc', align: 'left', width: '' },
        { title: '是否强制升级', dataIndex: 'isForceDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        version: undefined,
        appId: undefined,
        osType: undefined
      },
      listApi: {
        url: '/appVersion/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addAppVersion',
        addTitle: '新增版本',
        editTitle: '修改版本'
      },
      deleteParam: {
        url: '/appVersion/',
        // param: {pk_key: 'appVersionId', pk_val: ''},
        title: '版本',
        key: 'version'
      }
    };
  },
  created () {
    let paramArr = [
      {index: 1, scope: 'searchList', query: 'comu_app_type'},
      {index: 2, scope: 'searchList', query: 'comu_platform_type'}
    ];
    this.dictionarySelect(paramArr);
  },
  methods: {
    /* 下载二维码 */
    downloadQRcode (id) {
      this.$get({
        url: `/appVersion/qrcodeImg/${id}`,
        config: {responseType: 'blob'}
      }).then((res) => {
      }).catch((res) => {
        let isImg = res.headers['content-type'].indexOf('image') >= 0;
        if (isImg) {
          let data = res.data;
          this.imgUrl = window.URL.createObjectURL(new Blob([data], { type: data.type }));
          this.visible = true;
        } else {
          this.$message.error('二维码地址不存在');
        }
      });
    },
    confirm () {
      this.visible = false;
      this.imgUrl = '';
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
